<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ objEdicao.id }}</div>
            </div>

            <div class="form-item-char10">
                <label class="label-caption">Ano/Mês</label>
                <div class="field-label field-label-center">{{ objEdicao.anomes }}</div>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center">{{ objEdicao.protocolo }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ globalStore.nmusuario }}</div>
            </div>
        </div>


        <div v-if="!modoItens">
            <div class="row-end">
                <button v-if="objEdicao.anomes != 0" class="btn-confirm" @click="salvarCabecalho">Iniciar Preenchimento</button>
                <button @click="closeForm">Retornar</button>
            </div>
        </div>
        
    
        <div v-if="modoItens">
            <div class="row row-space">
                <div class="form-item-data">
                    <label class="label-caption">Recebimento</label>
                    <input type="date" v-model="objEdicaoItem.dtrecebimento" />
                </div>
                
                <ProdutoSelect class="form-item" :ckMp="true" :idAtividade="globalStore.atividade.id" v-model="produtoSelecionado" />

                <div class="form-item-char20">
                    <label class="label-caption">Quantidade</label>
                    <input type="text" class="input-right" v-model="edQuantidade" v-decimal />
                </div>

                <div class="form-item-char15">
                    <UnidadeMedidaSelect v-model:unidadeSelecionada="unidadeSelecionada" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-char30">
                    <label class="label-caption">Lote</label>
                    <input type="text" class="input-center" v-model="objEdicaoItem.lote" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Validade</label>
                    <input type="date" v-model="objEdicaoItem.dtvalidade" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Temperatura</label>
                    <input type="text" class="input-right" v-model="edTemperatura" v-decimal-signed />
                </div>

                <div class="form-item">
                    <label class="label-caption">Detalhamento Produto</label>
                    <input type="text" v-model="objEdicaoItem.detalhamento" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">                
                <div class="form-item" style="position:relative">
                    <label class="label-caption">Fornecedor</label>

                    <input
                        type="text"
                        v-model="objEdicaoItem.nmfornecedor"
                        maxlength="100"
                        v-uppercase
                        @focus="showSugestoesFornecedor = true"
                        @input="showSugestoesFornecedor = true"
                        @blur="esconderSugestoes"
                    />

                    <!-- dropdown -->
                    <ul
                        v-if="showSugestoesFornecedor && lsFornecedorFiltrado.length"
                        class="autocomplete-list"
                    >
                        <li
                            v-for="obj in lsFornecedorFiltrado"
                            :key="obj.id"
                            @mousedown.prevent="selecionaFornecedor(obj)"
                        >
                            {{ obj.nmfornecedor }} — {{ obj.cpfcnpj }}
                        </li>
                    </ul>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">CPF/CNPJ</label>
                    <input type="text" class="input-center" v-model="objEdicaoItem.cpfcnpj_fornecedor" v-mask-cpf-cnpj maxlength="18"/>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Nro Documento (NF)</label>
                    <input type="text" class="input-right" v-model="edNroDocOrigem" v-number />
                </div>

                <div class="form-item-char30">
                    <label class="label-caption">SIF/SIE Origem</label>
                    <input type="text" v-model="objEdicaoItem.sif_origem" maxlength="50" v-uppercase />
                </div>
            </div>


            <div class="row-end">
                <button class="btn-confirm" @click="salvarItem">Salvar Ítem</button>
                <button class="btn-cancel" @click="abrirModal">Encerrar e Assinar</button>
                <button @click="closeForm">Sair</button>
            </div>
        </div>
    </div>

    <div v-if="modoItens && lsItens.length>0">
        <div class="table-wrapper"><table>
            <thead>
                <tr>
                    <th class="col-width-char10">Data</th>
                    <th>Produto</th>
                    <th class="col-width-char20">Detalhamento</th>
                    <th class="col-width-char40">Fornecedor</th>
                    <th class="col-width-char15">Quantidade</th>
                    <th class="col-width-char10">Unidade</th>
                    <th class="col-width-char05"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtrecebimento) }}</td>
                    <td>{{ obj.nmproduto }}</td>
                    <td class="col-width-char20">{{ obj.detalhamento }}</td>
                    <td class="col-width-char40">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.qtd) }}</td>
                    <td class="col-width-char10 center">{{obj.unidade }}</td>
                    <td class="col-width-char05"><div class="row-left">
                        <button class="btn-icon btn-icon--trash" @click="excluiItem(obj)"></button>
                    </div></td>
                </tr>
            </tbody>
        </table></div>
    </div>

    
    <ConfirmModal ref="confirmModal" />
    

    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />

    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { onMounted, ref, computed } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarAssinatura } from '@/models/assinatura';
import { criarPlaMp } from '@/models/plaMp';
import { criarPlaMpItem } from '@/models/plaMpItem';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import ProdutoSelect from '@/selects/ProdutoSelect.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';
import UnidadeMedidaSelect from '@/selects/estaticos/UnidadeMedidaSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const ckEmiteSalvo = ref(false);
const confirmModal = ref(null);
const edNroDocOrigem = ref(null);
const edQuantidade = ref(null);
const edTemperatura = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const modoItens = ref(false);
const msgAlerta = ref(null);
const msgOkModal = ref('Planilha encerrada e homologada com sucesso.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref(criarPlaMp());
const objEdicaoItem = ref(criarPlaMpItem());
const produtoSelecionado = ref(null);
const showOkModal = ref(false);
const unidadeSelecionada = ref(null);


// CONTROLES PARA LISTA DE FORNECEDORES CADASTRADOS
const lsDadosMain = ref([]);
const showSugestoesFornecedor = ref(false);
const lsFornecedorFiltrado = computed(() => {
    const termo = objEdicaoItem.value.nmfornecedor?.trim().toLowerCase() || '';
    if (!showSugestoesFornecedor.value || termo === '') return [];
    return lsDadosMain.value
        .filter(obj => obj.nmfornecedor.toLowerCase().includes(termo))
        .slice(0, 10);          // limita a 10 resultados (opcional)
});

function selecionaFornecedor(obj) {
    objEdicaoItem.value.nmfornecedor            = obj.nmfornecedor;
    objEdicaoItem.value.cpfcnpj_fornecedor      = obj.cpfcnpj;
    objEdicaoItem.value.sif_origem              = obj.sif_origem;
    showSugestoesFornecedor.value = false;
}

function esconderSugestoes() {
    requestAnimationFrame(() => (showSugestoesFornecedor.value = false));
}
// ------------------------------------------------

async function abrirModal() {
    encerrarDigitacao();
}

const closeForm = () => {
    if (ckEmiteSalvo.value) emit('save');
    emit('close'); 
};

async function encerrarDigitacao(){
    try{
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        isLoading.value=true;

        objAssinatura.value.idep            = globalStore.idep;
        objAssinatura.value.idusuario       = globalStore.idusuario;
        objAssinatura.value.idsessao        = globalStore.idlogin;
        objAssinatura.value.nmusuario       = globalStore.nmusuario;
        objAssinatura.value.vssistema       = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo    = `REF:PLAMP|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.protocolo}`;
        objAssinatura.value.ass_senha       = senhaDigitada;
        objAssinatura.value.ass_tipoauth    = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem    = objEdicao.value.id;
        objAssinatura.value.doc_tipo        = 'PLAMP';

        const respAss = await Api.genericPut('/pla/plamp/homologar', objAssinatura.value);
        if (respAss.bolok === 1){
            ckEmiteSalvo.value=true;
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const excluiItem = async(item) => {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma exclusão do ítem?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        try{
            msgAlerta.value=null;
            isLoading.value=true;
            await Api.genericDelete({id: item.id, strparam1: 'plamp_itens', idusuario: globalStore.idusuario});
            await lerItens();
        } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
        }finally{isLoading.value=false;}
    }
}

const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        let req=null;
        if (props.idEdicao==0){
            req = await Api.genericGet('/pla/plamp_new', {idestabelecimento: globalStore.idestabelecimento});
            Object.assign(objEdicao.value, req);
        }else{
            req = await Api.genericGet('/cad/plamp', {id: props.idEdicao});
            Object.assign(objEdicao.value, req[0]);
            modoItens.value=true;
            await lerItens();
        }

        req = await Api.genericPost('/listas/estabelecimentos/for', {
            idep: globalStore.idep,
            idestabelecimento: globalStore.idestabelecimento,
            ativo: 'S'});
        lsDadosMain.value = req;

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
};

async function lerItens(){
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const itens = await Api.genericPost('/lspla/plamp/itens', {id: objEdicao.value.id});
        lsItens.value = itens;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


const salvarItem = async () => {
    msgAlerta.value = salvarItemDadosOk();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;

        objEdicaoItem.value.id = 0;
        objEdicaoItem.value.idplamp = objEdicao.value.id;
        objEdicaoItem.value.idproduto = produtoSelecionado.value.id;
        objEdicaoItem.value.nrdoc_origem = Funcoes.integerFromString(edNroDocOrigem.value);
        objEdicaoItem.value.qtd = Funcoes.decimalFromString(edQuantidade.value);
        objEdicaoItem.value.unidade = unidadeSelecionada.value,
        objEdicaoItem.value.temperatura = Funcoes.decimalFromString(edTemperatura.value);
        objEdicaoItem.value.idlogin = globalStore.idlogin;
        objEdicaoItem.value.idusuario = globalStore.idusuario;

        const response  = await Api.genericPut('/cad/plamp_item', objEdicaoItem.value);
        if (response.bolok === 1){
            ckEmiteSalvo.value=true;
            edQuantidade.value = null;
            lerItens();
        }else{
            msgAlerta.value=response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
}


function salvarItemDadosOk(){ 
    let r = Validar.dataNoMes(objEdicaoItem.value.dtrecebimento, objEdicao.value.anomes);
    if (!r.ok) return `Data recebimento: ${r.msg}`;
    r = Validar.id(produtoSelecionado.value, 'Informe o produto');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(edQuantidade.value, 'Informe a quantidade');
    if (!r.ok) return r.msg;
    if (!unidadeSelecionada.value) return 'Informe a unidade de medida';
    return null;
}


const salvarCabecalho = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const response = await Api.genericPut('/cad/plamp', objEdicao.value);
        if (response.bolok === 1){
            if (objEdicao.value.id===0) objEdicao.value.id = response.id;
            ckEmiteSalvo.value=true;
            modoItens.value=true;
            await lerItens();
        }else{msgAlerta.value=`ATENÇÃO: ${response.erro}`;}
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


onMounted(lerDados);
</script>

<style scoped>
.autocomplete-list {
    position: absolute;
    top: 100%;          /* logo abaixo do input */
    left: 0;
    right: 0;
    max-height: 200px;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    z-index: 50;        /* garante que fique acima do resto */
    box-shadow: 0 2px 4px rgba(0,0,0,.1);
}

.autocomplete-list li {
    padding: 4px 8px;
    text-align: left;
    cursor: pointer;
    user-select: none;
}

.autocomplete-list li:hover {
    background: #f2f2f2;
}
</style>